import React, { FC, useRef, useEffect } from 'react';

import { RestrictionsType, Restrictions } from '@shared/ui/Restrictions';
import { useTheme } from '../../../../../theme';
import { Checkbox, Tooltip } from '../../../../../BaseComponents';
import { FormControlLabel } from '@mui/material';
import { SafeHtml } from '@shared/ui';

interface Props {
	restrictions: RestrictionsType[];
	consentText: string;
	tooltipText: string;
	showTooltip?: boolean;
	isAccepted: boolean;
	onAcceptChange: (e: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
}

const RestrictionsStep: FC<Props> = ({
	restrictions,
	consentText,
	tooltipText,
	showTooltip,
	isAccepted,
	onAcceptChange
}) => {
	const { RestrictionsStep: css } = useTheme('Entities').Restrictions;

	const ref = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (ref.current && showTooltip) {
			ref.current.scrollIntoView({ behavior: 'smooth' });
		}
	}, [showTooltip]);

	return (
		<div className={css.root}>
			<div className={css.container}>
				<div className={css.restrictions}>
					{restrictions.map((restriction, index) => (
						<Restrictions key={index} {...restriction} />
					))}
				</div>

				<div className={css.checkbox__wrapper} ref={ref}>
					<FormControlLabel
						classes={{ root: css.checkbox__root }}
						checked={isAccepted}
						control={
							<Tooltip open={showTooltip} title={tooltipText}>
								<Checkbox required={showTooltip} onChange={onAcceptChange} />
							</Tooltip>
						}
						label={
							<span className={css.checkbox__label}>
								<SafeHtml tag="span" html={consentText} />
							</span>
						}
					/>
				</div>
			</div>
		</div>
	);
};

export default RestrictionsStep;
